import { render, staticRenderFns } from "./IconLayout.vue?vue&type=template&id=1f7de5e8&"
import script from "./IconLayout.vue?vue&type=script&lang=js&"
export * from "./IconLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports